import axios from 'axios';

export const createClient = ({
  baseURL,
  timeout = 20000,
  withCredentials = true,
  getAuthToken,
  getEntityId,
}) => {
  const api = axios.create({
    baseURL,
    timeout,
    withCredentials,
  });

  // Attach auth token and entityId if present
  api.interceptors.request.use((config) => {
    if (getAuthToken) {
      const token = getAuthToken();
      if (token) {
        config.headers.Authorization = token;
      }
    }
    if (getEntityId) {
      const entityId = getEntityId();
      if (entityId) {
        config.headers['entityId'] = entityId;
      }
    }
    return config;
  });

  // Normalize success & error
  api.interceptors.response.use(
    (response) => response.data,
    (error) => {
      return Promise.reject({
        status: error?.response?.status,
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Something went wrong',
        data: error?.response?.data,
      });
    }
  );

  return {
    get: (url, config) => api.get(url, config),
    post: (url, data, config) => api.post(url, data, config),
    put: (url, data, config) => api.put(url, data, config),
    del: (url, config) => api.delete(url, config),
    raw: api,
  };
};
